<template>
    <div class="users-style">

        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance Settings<span>
                <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance Settings
                /
                Holidays</span>
        </h4>

        <div class="mt-4 ibox px-3 py-4">
            <div class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0 pt-0 pb-0 roster-ibox">
                <h4 class="clearfix mb-0">
                    <span class="float-left">Holidays
                        <span class="title-sub-text"></span>
                    </span>
                    <span class="float-right"></span>
                </h4>
            </div>
            <div class="row no-gutters py-2 mb-3 pl-0 ">
                <div class="col-sm-3 mt-1">
                    <div class="custom-search">
                        <b-input-group class="mb-2">
                            <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="search" placeholder="Search.. " v-model="search"
                                @input="resetPagination()"></b-form-input>
                        </b-input-group>
                    </div>
                </div>
                <div class="col-sm-1"></div>
                <div class="col-sm-3 pr-0 cursor-pointer text-left mt-2">
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            Year
                        </b-input-group-prepend>
                        <b-form-select plain id="year" name="year" v-model="year" :options="$year_options"
                            @change="resetPagination(); getHoliDays()"></b-form-select>
                    </b-input-group>


                </div>
                <div class="col-sm-5 pr-0 cursor-pointer text-right company-form-box-title">
                    <b-button v-b-modal.bv-modal-govt-holiday>Sync Government Holidays</b-button>
                    <b-button id="show-btn" @click="addNewHoliday()"><b-icon icon="plus"></b-icon> Add
                        Holiday</b-button>
                </div>
            </div>

            <b-overlay :show="showoverlay" rounded="sm">
                <table class="table dataTable">
                    <thead>
                        <tr class="table-head">

                            <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)"
                                :class="sortKey == column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                                class="cursor-pointer"><span>{{ column.label }}</span></th>
                            <th class="text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="hover-bg table-row border-bottom mx-2" v-for="holiday in paginatedData"
                            :key="holiday.id">
                            <td>{{ holiday.holiday_date }}</td>
                            <td>{{ holiday.holiday_type }}</td>
                            <td>{{ holiday.comment }}</td>
                            <td>

                                <div class="float-right position-relative">
                                    <b-button-toolbar>
                                        <a :id="'actionDropdown_' + holiday.id" class="dropdown-toggle clearfix action-dropdown-toggle"
                                            href="#" role="button" data-toggle="dropdown" aria-haspopup="true"
                                            aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                        <div class="dropdown-menu action-dropdown-menu"
                                            :aria-labelledby="'actionDropdown_' + holiday.id">
                                            <b-button-group>

                                                <b-button variant="outline-secondary" v-if="ce"
                                                    @click="updateHoliday(holiday.id)">
                                                    <b-icon icon="pencil"></b-icon> Edit
                                                </b-button>
                                                <b-button variant="outline-secondary" v-if="ce"
                                                    @click="deleteHoliday(holiday.id)">
                                                    <b-icon icon="trash"></b-icon> Delete
                                                </b-button>

                                            </b-button-group>
                                        </div>
                                    </b-button-toolbar>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="paginatedData.length > 0">
                            <td :colspan="6" class="no-border">
                                <div class="row p-2 float-right">
                                    <b-pagination-nav v-model="pagination.currentPage"
                                        :number-of-pages="pagination.pages" base-url="#" prev-text="Previous"
                                        next-text="Next" first-number last-number></b-pagination-nav>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="paginatedData.length == 0">
                            <td :colspan="6" class="text-center">{{ blankmsg }}</td>
                        </tr>
                    </tbody>
                </table>
            </b-overlay>
        </div>


        <b-modal id="bv-modal-newholiday" size="lg" hide-footer :title="modalTitle">
            <b-overlay :show="showoverlay">
            <div class="card-body">
                <div>Select Day / Range</div>
                <div class="row">
                    <div class="col-sm-6">
                        <b-form-group id="holiday_one-group" label="From" class="" label-for="holiday_one">
                            <b-form-datepicker id="holiday_one" name="holiday_one" @input="updateToDate()"
                                v-model="holiday_one"></b-form-datepicker>
                        </b-form-group>
                    </div>
                    <div class="col-sm-6">
                        <b-form-group id="holiday_two-group" label="To" class="" label-for="holiday_two">
                            <b-form-datepicker id="holiday_two" name="holiday_two" :min="holiday_one"
                                v-model="holiday_two"></b-form-datepicker>
                        </b-form-group>
                    </div>
                </div>
                <div class='row mt-2'>


                    <div class="col-sm-6">
                        <b-form-group id="holiday_type-group" label="Type" class="" label-for="holiday_type">
                            <b-form-select id="holiday_type" name="holiday_type" v-model="fdata.holiday_type"
                                :options="holiday_types" @change="getEmployees"></b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-sm-6">
                        <b-form-group id="comment-group" label="Reason/Comment" label-for="comment"
                            class="required-field">
                            <b-form-textarea id="comment" name="comment" rows="3" max-rows="6" no-resize
                                v-model="fdata.comment" v-validate="{ required: true, min: 3 }"
                                :state="validateState('comment')" aria-describedby="comment-feedback"
                                data-vv-as="Reason/Comment"></b-form-textarea>
                            <b-form-invalid-feedback id="comment-feedback">{{ veeErrors.first('comment')
                            }}</b-form-invalid-feedback>
                        </b-form-group>
                        <div class="clearfix">

                            <div class="float-right font-italic">Day(s) : {{ dateDiff }}</div>
                        </div>

                    </div>

                    <div class="col-sm-12" v-if="fdata.holiday_type == 2">
                        <common-list :pageurl="$api_url" :is_action="0" :checkbox="1" :appended_column="appended_column"
                            :key="list_key" :company_options="company_options" :employees="employees" :default_column="default_column"
                            :primary_key="primary_key" :all_employee="'no'" v-on:childToParent="listReturn"></common-list>
                    </div>

                    <div class="full-width text-center mt-3">
                        <b-button variant="primary" @click="saveHoliDays()">Save</b-button>
                        <b-button class="ml-2 custom-wizard-btn" @click="$bvModal.hide('bv-modal-newholiday')"
                            variant="primary">Cancel</b-button>
                    </div>

                </div>
            </div>
            </b-overlay>
        </b-modal>


        <b-modal id="bv-modal-holiday" size="lg" hide-footer v-bind:title="modalTitle">
            <b-overlay :show="showoverlay">
            <div class="card-body">
                <div>Select Day</div>
                <div class="row">
                    <div class="col-sm-6">
                        <b-form-group id="holiday_date-group" label="Date" label-for="holiday_date">
                            <b-form-datepicker id="holiday_date" v-model="holiday.holiday_date" show-decade-nav
                                :min="min"></b-form-datepicker>
                        </b-form-group>
                    </div>
                </div>
                <div class='row mt-2'>

                    <div class="col-sm-6">
                        <b-form-group id="holiday_type_update-group" label="Type" label-for="holiday_type_update">
                            <b-form-select id="holiday_type_update" name="holiday_type" v-model="holiday.holiday_type"
                                :options="holiday_types" @change="getEmployees"></b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-sm-6">
                        <b-form-group id="comment_update-group" label="Reason/Comment" label-for="comment_update"
                            class="required-field">
                            <b-form-textarea id="comment_update" name="comment_update" rows="3" max-rows="6" no-resize
                                v-model="holiday.comment" v-validate="{ required: true, min: 3 }"
                                :state="validateState('comment_update')" aria-describedby="comment_update-feedback"
                                data-vv-as="Reason/Comment"></b-form-textarea>
                            <b-form-invalid-feedback id="comment_update-feedback">{{ veeErrors.first('comment_update')
                            }}</b-form-invalid-feedback>
                        </b-form-group>
                    </div>

                    <div class="col-sm-12" v-if="holiday.holiday_type == 2">
                        <common-list :pageurl="$api_url" :is_action="0" :checkbox="1" :appended_column="appended_column"
                            :preselected="holiday.employee_ids || []" :key="list_key" :company_options="company_options" :employees="employees" :default_column="default_column"
                            :primary_key="primary_key" :all_employee="'no'" v-on:childToParent="listReturn"></common-list>
                    </div>

                    <div class="full-width text-center mt-3">
                        <b-button variant="primary" @click="onSubmitHolidayUpdate()">Save</b-button>
                        <b-button class="ml-2 custom-wizard-btn" @click="$bvModal.hide('bv-modal-holiday')"
                            variant="primary">Cancel</b-button>
                    </div>

                </div>
            </div>
            </b-overlay>
        </b-modal>

        <b-modal id="bv-modal-govt-holiday" size="lg" hide-footer title="List Of Approved Government Holidays In This Year">
            <roster-company-government-holidays v-on:childToParent="getHoliDays"></roster-company-government-holidays>
        </b-modal>
    </div>
</template>
<script>

import moment from 'moment';

export default {
    data() {

        let sortOrders = {};
        let columns = [
            { label: 'Date', name: 'holiday_date', type: 'date' },
            { label: 'Type', name: 'holiday_type' },
            { label: 'Title', name: 'comment' },
        ];
        columns.forEach((column) => { sortOrders[column.name] = -1; });

        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const minDate = new Date(today)
        minDate.setDate(minDate.getDate() + 1)
        const startdate = moment(minDate).format('YYYY-MM-DD');

        return {
            ce: true,
            showoverlay: false,
            holiday_one: startdate,
            holiday_two: startdate,
            fdata: { id: 0, holiday_one: startdate, holiday_two: startdate, days: 1, comment: null, holiday_type: "0" },
            holiday: {},
            min: startdate,

            holidays: [],

            holiday_types: [
                { value: "0", text: "Government" },
                { value: "1", text: "Company" },
                { value: "2", text: "Custom" },
            ],
            list_key: 0,
            appended_column: [],
            company_options: [],
            default_column: ['name', 'employee_code', 'jobposition', 'department'],
            employees: [],
            selected: [],
            primary_key: 'employee_id',

            year: now.getFullYear(),

            columns: columns,
            sortKey: 'holiday_date',
            sortOrders: sortOrders,
            search: '',

            length: 10,
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },
            blankmsg: 'Fetching data..',
            modalTitle: 'Add Holiday',
        }
    },
    methods: {
        listReturn(data){
            this.selected = data.selected;
        },

        getEmployees: function(type)
        {
            if(type != 2) {
                return;
            }
            if(!this.checkNet()) return false;
            if(this.employees.length > 0) {
                this.list_key++;
                return;
            }
            this.showoverlay = true;
            axios.get(this.$api_url+'/employee/list').then((response) => {
                this.employees = response.data.employee_data;
                    this.company_options = response.data.options;
                    this.list_key++;
                    this.showoverlay = false;

                }).catch((error) => {
                    this.serverError(error);
                    this.showoverlay = false;
                });
        },
        sortBy(key) {
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;
        },
        resetPagination() {
            this.pagination.currentPage = 1;
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] === value);
        },
        updateToDate: function () {
            this.holiday_two = this.holiday_one;
        },
        formatdate: function (x) {
            return moment(x).format('YYYY-MM-DD');
        },
        checkGaterDate(x) {
            return moment(x).isAfter(moment(new Date()).format('YYYY-MM-DD'));
        },
        updateHoliday: function (x) {
            this.selected = [];
            axios.get(this.$api_url + '/leave-attendance/company/holiday?id=' + x).then(function (response) {
                this.holiday = response.data;
                if (this.holiday.holiday_type !== undefined && this.holiday.holiday_type !== null) {
                    this.holiday.holiday_type = String(this.holiday.holiday_type);
                }
                this.selected = Array.isArray(this.holiday.employee_ids) ? this.holiday.employee_ids : [];
                this.getEmployees(this.holiday.holiday_type);

            }.bind(this)).catch((error) => { this.serverError(error); });
            this.modalTitle = 'Edit Holiday';
            this.$bvModal.show('bv-modal-holiday');
            this.$nextTick(() => { this.$validator.reset(); });
        },
        deleteHoliday: function (x) {
            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this holiday.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);
                        axios.post(this.$api_url + '/leave-attendance/company/holiday/delete', formData).then(function (response) {
                            this.$bvToast.toast('Sucessfully deleted', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });

                            this.getHoliDays();

                        }.bind(this))
                            .catch(function (error) {
                                currentObj.serverError(error);
                            });
                    }


                });
        },
        onSubmitHolidayUpdate: function () {
            this.$validator.validate('comment_update').then(valid => {
                if (valid) this.submitHolidayUpdate();
            });
        },
        submitHolidayUpdate: function () {
            let currentObj = this;
            let formData = new FormData();
            for (let [key, value] of Object.entries(this.holiday)) {
                if (value === null || value === undefined || typeof value === 'object') continue;
                formData.append(key, value);
            }
            if (this.holiday.holiday_type == 2) {
                formData.append('employee_ids', JSON.stringify(this.selected));
            }
            axios.post(this.$api_url + '/leave-attendance/company/holidays/save', formData,)
                .then(function (response) {
                    if (response.data.status) {
                        this.getHoliDays();
                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        this.$bvModal.hide('bv-modal-holiday');
                    }
                    else {
                        this.$bvToast.toast(response.data.message, {
                            title: `Warning`,
                            variant: 'warning',
                            solid: true
                        });
                    }


                }.bind(this))
                .catch(function (error) {
                    currentObj.serverError(error);
                });
        },
        addNewHoliday() {
            this.modalTitle = 'Add Holiday';
            this.resetForm();
            this.$bvModal.show('bv-modal-newholiday');
        },
        resetForm() {
            const startdate = moment().add(1, 'days').format('YYYY-MM-DD');
            this.holiday_one = startdate;
            this.holiday_two = startdate;
            this.fdata = { id: 0, holiday_one: startdate, holiday_two: startdate, days: 1, comment: null, holiday_type: "0" };
            this.selected = [];
            this.$nextTick(() => { this.$validator.reset(); });
        },
        getHoliDays: function () {
            if (!this.checkNet()) return false;
            this.showoverlay = true;
            axios.get(this.$api_url + '/leave-attendance/company/holidays?year=' + this.year).then(function (response) {

                this.holidays = response.data.holidays || [];
                if (this.holidays.length == 0) {
                    this.blankmsg = "Nothing found.";
                }

            }.bind(this))
                .catch((error) => { this.serverError(error); })
                .finally(() => { this.showoverlay = false; });

            this.$bvModal.hide('bv-modal-govt-holiday');

        },
        saveHoliDays: function () {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                if (!this.fdata.days) {
                    this.$bvToast.toast('Please select a valid date range.', { title: `Warning`, variant: 'warning', solid: true });
                    return;
                }

                let currentObj = this;
                let formData = new FormData();
                for (let [key, value] of Object.entries(this.fdata)) {
                    if (value === null || value === undefined) continue;
                    formData.append(key, value);
                }
                if(this.fdata.holiday_type == 2) {
                    formData.append('employee_ids', JSON.stringify(this.selected));
                } else {
                    this.selected = [];
                    this.list_key++;
                }
                axios.post(this.$api_url + '/leave-attendance/company/holidays/save', formData,)
                    .then(function (response) {
                        if (response.data.status) {
                            this.getHoliDays();
                            this.$bvToast.toast('Saved!', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });

                            this.$bvModal.hide('bv-modal-newholiday');
                        }
                        else {
                            this.$bvToast.toast(response.data.message, {
                                title: `Warning`,
                                variant: 'warning',
                                solid: true
                            });
                        }


                    }.bind(this))
                    .catch(function (error) {
                        currentObj.serverError(error);
                    });

            });
        },
    },
    created: function () {
        this.getHoliDays();
        this.sortBy('holiday_date');
    },
    computed:
    {
        dateDiff() {
            let holiday_one = moment(this.holiday_one, 'YYYY-MM-DD');
            let holiday_two = moment(this.holiday_two, 'YYYY-MM-DD');

            this.fdata.holiday_one = holiday_one.format('YYYY-MM-DD');
            this.fdata.holiday_two = holiday_two.format('YYYY-MM-DD');

            let days = holiday_two.startOf('day').diff(holiday_one.startOf('day'), 'days');

            if (days < 0) {
                this.fdata.days = 0;
                return 'Invalid Date Range';
            }

            this.fdata.days = days + 1;
            return days + 1;
        },

        filteredData() {
            let filtered_list = this.holidays.map(v => {
                let type = this.holiday_types.find(t => t.value == v.holiday_type);
                return { ...v, holiday_type: type ? type.text : v.holiday_type };
            });

            if (this.search) {
                filtered_list = filtered_list.filter((row) => {
                    return Object.keys(row).some((key) => {
                        return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;
                    });
                });

                if (filtered_list.length == 0)
                    this.blankmsg = "Nothing found.";
            }

            let sortKey = this.sortKey;
            let order = this.sortOrders[sortKey] || 1;
            if (sortKey) {
                filtered_list = filtered_list.slice().sort((a, b) => {
                    let index = this.getIndex(this.columns, 'name', sortKey);
                    a = String(a[sortKey]).toLowerCase();
                    b = String(b[sortKey]).toLowerCase();
                    if (this.columns[index] && this.columns[index].type == 'date') {
                        return (a == b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                    } else if (this.columns[index] && this.columns[index].type == 'number') {
                        return (+a == +b ? 0 : +a > +b ? 1 : -1) * order;
                    } else {
                        return (a == b ? 0 : a > b ? 1 : -1) * order;
                    }
                });
            }

            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        }

    }
}
</script>